import {
    Button,
    Footer,
    IconLib,
    Popover,
    PopoverAnchor,
    Portal,
    stopEvent,
    useTheme,
    useVisibility,
    View,
} from '@fold-dev/core'
import React, { ReactElement, useRef } from 'react'
import { LabelSelect, LabelSelectLabel } from './label-select'
import { ToolbarButton } from './toolbar-button'
import { Labels } from './labels'
import { ActionButton } from './action-button'

export type LabelButtonProps = {
    shorten?: boolean
    labels: LabelSelectLabel[]
    onAdd?: (label: LabelSelectLabel) => void
    onDelete?: (label: LabelSelectLabel) => void
    portal?: any
    disabled?: boolean
    dontHideActionButton?: boolean
    anchor?: any
}

export const LabelButton = (props: LabelButtonProps) => {
    const { labels = [], onAdd, onDelete, portal, disabled, anchor, shorten, dontHideActionButton } = props
    const { visible, show, hide } = useVisibility()
    const ref = useRef(null)

    return (
        <Popover
            portal={portal}
            width={300}
            preferredHorizontalAnchor={anchor ? anchor.horizontal : undefined}
            preferredVerticalAnchor={anchor ? anchor.vertical : undefined}
            border="none"
            isVisible={visible}
            onDismiss={hide}
            content={
                <div
                    onMouseDown={stopEvent}
                    onClick={stopEvent}>
                    <LabelSelect
                        labels={labels}
                        onAdd={onAdd}
                        onDelete={onDelete}
                        onDismiss={hide}
                        // footer={
                        //     <Footer
                        //         p="0.5rem 0.5rem 0 0"
                        //         justifyContent="flex-end">
                        //         <Button
                        //             size="sm"
                        //             variant="accent"
                        //             onClick={hide}>
                        //             Okay
                        //         </Button>
                        //     </Footer>
                        // }
                    />
                </div>
            }>
            <div
                onMouseDown={stopEvent}
                className="f-label-button f-row">
                {(!labels.length || dontHideActionButton) && (
                    <ActionButton
                        border
                        onClick={show}
                        className={visible ? 'hide-is-open' : 'hide'}>
                        <IconLib
                            icon="tag"
                            size="sm"
                        />
                    </ActionButton>
                )}
                <Labels
                    shorten={shorten}
                    disabled={disabled}
                    labels={labels}
                    onClick={show}
                />
            </div>
        </Popover>
    )
}
